<template>
  <div class="ficha-mapa ficha-avistamiento-fauna">
    <div class="encabezado">Avistamiento de fauna</div>
    <Carousel
      class="oculto-escritorio"
      :altura="300"
      :id='"carrusel-avistamiento"'
      :lista='lista_fotos'
    />
    <div class="contenedor">
      <div class="texto-fauna">
        <p class="m-y-0">
          La disminución de la disponibilidad de agua y la eliminación de la
          vegetación en el Lago de Texcoco alteró la dinámica ecológica
          provocando la reducción y desaparición de nichos ecológicos y hábitat
          para aves.
        </p>
        <img :src="`${cdn_archivos_dominio}/diagnostico/fichas/ficha6_fauna_barrasbeead3f3.png`" alt="" class="vis m-b-1">
      </div>
      <div class="contenedor-fauna oculto-movil">
        <div class="ficha-foto" v-for="(item, i) in lista_fotos" :key="i">
          <img class="foto" :src="item[0]" alt="" />
          <div class="degradado"></div>
          <div class="cuadro-contraste"></div>
          <p class="pie-foto">{{item[1]}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Carousel from '@/components/base/Carousel.vue';

export default {
  name: "AvistamientoDeFauna",
  components: {
    Carousel
  },
  data(){
    return {
      lista_fotos:[
        [require('@/assets/fichas-diagnostico/ficha6/fauna/1-Fauna.jpg'),"Avoceta americana"],
        [require('@/assets/fichas-diagnostico/ficha6/fauna/2-Fauna.jpg'),"Insectos"],
        [require('@/assets/fichas-diagnostico/ficha6/fauna/3-Fauna.jpg'),"Teporingo"],
        [require('@/assets/fichas-diagnostico/ficha6/fauna/4-Fauna.jpg'),"Hongos"],
        [require('@/assets/fichas-diagnostico/ficha6/fauna/5-Fauna.jpg'),"Reptiles"],
        [require('@/assets/fichas-diagnostico/ficha6/fauna/6-Fauna.jpg'),"Arácnidos"],
        [require('@/assets/fichas-diagnostico/ficha6/fauna/7-Fauna.jpg'),"Peces"],
        [require('@/assets/fichas-diagnostico/ficha6/fauna/8-Fauna.jpg'),"Ajolote"]
      ]
    }
  },
  computed: {
    ...mapState(["cdn_archivos_dominio"]),
  },
};
</script>

<style scoped lang="scss">
$ficha-separador: 20px;
.texto-fauna {
  font-size: 14px;
  padding: 0 $gap*.5;
  .vis {
    margin: $gap*.5 0;
    width: 100%;
  }
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    flex: 1 0 35%;
    width: 35%;
    .vis {
      width: 75%;
    }
  }
}
@media (min-width: map-get($media-queries-limit, "mobile")) {
  div.oculto-escritorio{
    display: none;
  }
  div.oculto-movil{
    display: grid;
  } 
}
@media (max-width: map-get($media-queries-limit, "mobile")) {
  div.oculto-escritorio{
    display: inherit;
  }
  div.oculto-movil{
    display: none;
  }
}
.carrusel-cuerpo{
    padding: 0 30px;
    margin-bottom: 20px;
  }
.contenedor-fauna {
  
  .ficha-foto {
    margin: $gap*.5;
  }
  
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: $ficha-separador;
    margin: 0 $gap*.5 $ficha-separador 0;
    .ficha-foto {
      margin: 0;
      width: 100%;
      .foto {
        object-fit: cover;
        height: 100%;
      }
      .pie-foto {
        bottom: $gap * -.5;
      }
    }
  }
}
</style>
